module.exports = __webpack_public_path__ + "static/media/Rectangle 12886.5bc22a1a.png";